import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import ElevatorKindRespons from "./ElevatorKindRespons"
import ElevatorCovarage from "./ElevatorCovarage"
import AddIcon from "@material-ui/icons/Add"
import ElevatorPriceKind from "./ElevatorPriceKind";
import ElevatorPriceUses from "./ElevatorPriceUses";
import ElevatorStops from "./ElevatorStops";
import ElevatorPriceLifeTime from "./ElevatorLifeTime";

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePriceElevator extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  elevator_price_id: "",
                  selectedCompany: "",
                  selectedKind: "",
                  elevator_price_kind_percent: "",
                  selectedUses: "",
                  elevator_price_min_floor: "",
                  // elevator_price_amount: "",
                  elevator_price_extraprice_nodoor: "",
                  // elevator_price_rate: "",
                  elevator_price_extrapercent_nodoor: "",
                  elevator_price_max_floor: "",
                  elevator_price_from_year: "",
                  elevator_price_until_year: "",
                  elevator_price_disc: "",
                  elevator_price_deactive: "0",
                  elevator_price_process_mode: "0",
                  company_logo_url: "",
                  orderBy: "elevator_price_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newPriceElevator: true,
                  optionCompany: [],
                  optionKind: [],
                  elevatorPriceKinds: [],
                  elevatorPriceUseCaseTypes : [],
                  elevatorPriceStops : [],
                  elevatorPriceLifeTimes : [],
                  elevator_usecase_type_percent: "",
                  optionUses: [],
                  openDialog: false,
                  elevatorKindRespons: [],

                  elevatorDisc: [],
                  elevator_price_kindrespons_price: "",
                  elevator_price_covarage_price: "",
                  elevator_price_from_person: "",
                  elevator_price_to_person: "",
                  to_stops: "",
                  from_stops: "",
                  percent_stops: "",
                  from_life_time : "",
                  to_life_time : "",
                  percent_life_time: "",
                  selectedElevatorKindRespons: "",
                  selectedElevatorCoverage: "",
                  selectedElevatorKinddoor : "",
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      handleKind = (selectedKind) => {
            this.setState({ selectedKind: selectedKind })
      }
      handleUses = (selectedUses) => {
            this.setState({ selectedUses: selectedUses })
      }

      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany }, () => {
                  this.filterPriceElevator()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ elevator_price_deactive: "0" })
            } else {
                  this.setState({ elevator_price_deactive: "1" })
            }
      }
      handleChangeProcessMode = (event) => {
            if (event.target.checked) {
                  this.setState({ elevator_price_process_mode: "1" })
            } else {
                  this.setState({ elevator_price_process_mode: "0" })
            }
      }

      handleElevatorKindRespons = (selectedElevatorKindRespons) => {
            this.setState({ selectedElevatorKindRespons: selectedElevatorKindRespons })
      }

      handleElevatorCoverage = (selectedElevatorCoverage) => {
            this.setState({ selectedElevatorCoverage: selectedElevatorCoverage })
      }

      handleElevatorKinddoor  = (selectedElevatorKinddoor ) => {
            this.setState({ selectedElevatorKinddoor : selectedElevatorKinddoor  })
      }


      handleChangeElevatorKindRespons = (event) => {
            console.log(event)
            this.setState({ elevator_price_kindrespons_price: event })
      }

      handleChangeElevatorCoverage = (event) => {
            this.setState({ elevator_price_covarage_price: event })
      }

      handleChangeFromPerson = (event) => {
            this.setState({ elevator_price_from_person: event })
      }
      handleChangeToPerson = (event) => {
            this.setState({ elevator_price_to_person: event })
      }





      handleSelectRows = (row2) => {
            this.ElevatorCovarage(row2.elevator_price_id)
            this.getElevatorKindRespons(row2.elevator_price_id)
            this.getElevatorPriceKinds(row2.elevator_price_id)
            this.getElevatorPriceUses(row2.elevator_price_id)
            this.getElevatorPriceStops(row2.elevator_price_id)
            this.getElevatorPriceLifeTime(row2.elevator_price_id)

            this.setState(
                  {
                        elevator_price_id: row2.elevator_price_id,

                        selectedCompany: { value: row2.elevator_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },
                        // selectedKind: { value: row2.elevator_price_kind_id, label: row2.elevator_kind_name },
                        // selectedUses: { value: row2.elevator_price_uses_id, label: row2.elevator_uses_name },
                        // elevator_price_amount: row2.elevator_price_amount,
                        elevator_price_extraprice_nodoor: row2.elevator_price_extraprice_nodoor,
                        // elevator_price_rate: row2.elevator_price_rate,
                        elevator_price_extrapercent_nodoor: row2.elevator_price_extrapercent_nodoor,
                        elevator_price_max_floor: row2.elevator_price_max_floor,
                        elevator_price_min_floor: row2.elevator_price_min_floor,
                        elevator_price_until_year: row2.elevator_price_until_year,
                        elevator_price_from_year: row2.elevator_price_from_year,
                        elevator_price_disc: row2.elevator_price_disc,

                        elevator_price_deactive: row2.elevator_price_deactive,
                        elevator_price_process_mode: row2.elevator_price_process_mode,
                        company_logo_url: row2.company_logo_url,
                        newPriceElevator: false,
                  },
                  () => {}
            )
      }

      newPriceElevator = (event) => {
            this.setState({
                  elevator_price_id: "",
                  selectedCompany: "",
                  // selectedKind: "",
                  // selectedUses: "",
                  elevator_price_deactive: "0",
                  elevator_price_process_mode: "0",
                  company_logo_url: "",
                  elevator_price_disc: "0",
                  // elevator_price_amount: "",
                  elevator_price_extraprice_nodoor: "",
                  // elevator_price_rate: "",
                  elevator_price_extrapercent_nodoor: "",
                  elevator_price_max_floor: "",
                  elevator_price_min_floor: "",
                  elevator_price_until_year: "",
                  elevator_price_from_year: "",
                  newPriceElevator: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getPriceElevator()
                                    self.getoptionCompany()
                                    self.getoptionKind()
                                    self.getoptionUses()
                                    self.getoptionElevatorKinddoor ()
                                    self.getoptionElevatorCoverage()
                                    self.getoptionElevatorKindRespons()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deletePriceElevator = () => {
            const { elevator_price_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getPriceElevator()
                              self.newPriceElevator()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_elevator_price")
            fd.append("elevator_price_id", elevator_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getPriceElevator() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterPriceElevator()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_elevator_price")

            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      ElevatorCovarage(elevator_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ elevatorDisc: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ elevatorDisc: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_covarage")
                  fd.append("elevator_price_id", elevator_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getElevatorKindRespons(elevator_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ elevatorKindRespons: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ elevatorKindRespons: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_kindrespons")
                  fd.append("elevator_price_id", elevator_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getElevatorPriceKinds(elevator_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ elevatorPriceKinds: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ elevatorPriceKinds: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_kind")
                  fd.append("elevator_price_id", elevator_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getElevatorPriceUses(elevator_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ elevatorPriceUseCaseTypes: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ elevatorPriceUseCaseTypes: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_use_case")
                  fd.append("elevator_price_id", elevator_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getElevatorPriceStops(elevator_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ elevatorPriceStops: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ elevatorPriceStops: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_stops")
                  fd.append("elevator_price_id", elevator_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getElevatorPriceLifeTime(elevator_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ elevatorPriceLifeTimes: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ elevatorPriceLifeTimes: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_life_time")
                  fd.append("elevator_price_id", elevator_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }


      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldcompany_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                                    self.filterPriceElevator()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldcompany")
            fd.append("fieldinsurance", "elevatorins")
            xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
            xhttp.send(fd)
      }

      getoptionElevatorKinddoor  = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].elevator_kinddoor_id, label: arr.data[k].elevator_kinddoor_name })
                              }
                              self.setState({ optionElevatorKinddoor : Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_elevator_kinddoor")
            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.send(fd)
      }

      getoptionElevatorKindRespons = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].elevator_kindrespons_id, label: arr.data[k].elevator_kindrespons_name })
                              }
                              self.setState({ optionElevatorKindRespons: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_elevator_kindrespons")
            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.send(fd)
      }



      getoptionElevatorCoverage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].elevator_coverage_id, label: arr.data[k].elevator_coverage_name })
                              }
                              self.setState({ optionElevatorCoverage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_elevator_coverage")
            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.send(fd)
      }


      getoptionKind = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].elevator_kind_id, label: arr.data[k].elevator_kind_name })
                              }
                              self.setState({ optionKind: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_elevator_kind")
            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.send(fd)
      }

      getoptionUses = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].elevator_uses_id, label: arr.data[k].elevator_uses_name })
                              }
                              self.setState({ optionUses: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_elevator_uses")
            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.send(fd)
      }

      saveNewPriceElevator = () => {
            const {
                  // elevator_price_amount,
                  elevator_price_extraprice_nodoor,
                  // elevator_price_rate,
                  elevator_price_extrapercent_nodoor,
                  elevator_price_max_floor,
                  elevator_price_min_floor,
                  elevator_price_until_year,
                  elevator_price_from_year,
                  elevator_price_disc,
                  selectedCompany,
                  // selectedKind,
                  // selectedUses,
                  elevator_price_deactive,
                  elevator_price_process_mode,
            } = this.state
            if (
                  selectedCompany !== "" &&
                  // selectedKind !== "" &&
                  // selectedUses !== "" &&
                  // elevator_price_amount !== "" &&
                  elevator_price_extraprice_nodoor !== "" &&
                  elevator_price_max_floor !== "" &&
                  elevator_price_min_floor !== "" &&
                  elevator_price_until_year !== "" &&
                  elevator_price_from_year !== "" &&
                  elevator_price_disc !== ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceElevator()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_elevator_price")

                  fd.append("elevator_price_fieldcompany_id", selectedCompany.value)
                  // fd.append("elevator_price_kind_id", selectedKind.value)
                  // fd.append("elevator_price_uses_id", selectedUses.value)
                  fd.append("elevator_price_min_floor", elevator_price_min_floor)
                  // fd.append("elevator_price_amount", elevator_price_amount)
                  fd.append("elevator_price_extraprice_nodoor", elevator_price_extraprice_nodoor)
                  // fd.append("elevator_price_rate", elevator_price_rate)
                  fd.append("elevator_price_extrapercent_nodoor", elevator_price_extrapercent_nodoor)
                  fd.append("elevator_price_max_floor", elevator_price_max_floor)
                  fd.append("elevator_price_from_year", elevator_price_from_year)
                  fd.append("elevator_price_until_year", elevator_price_until_year)
                  fd.append("elevator_price_disc", elevator_price_disc)
                  fd.append("elevator_price_deactive", elevator_price_deactive)
                  fd.append("elevator_price_process_mode", elevator_price_process_mode)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }
      saveNewPriceElevatorKindRespons = () => {
            const { elevator_price_id,  selectedElevatorKindRespons, elevator_price_kindrespons_price } = this.state
            if (selectedElevatorKindRespons != "" && elevator_price_kindrespons_price != "" ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ elevator_price_kindrespons_price: "",  selectedElevatorKindRespons: "" })
                                    self.getElevatorKindRespons(elevator_price_id)
                                    self.getElevatorPriceKinds(elevator_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_kindrespons")
                  fd.append("elevator_price_kindrespons_elevator_price_id", elevator_price_id)
                  fd.append("elevator_price_kindrespons_price", elevator_price_kindrespons_price)
                  fd.append("elevator_price_kindrespons_elevator_kindrespons_id", selectedElevatorKindRespons.value)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }


      saveNewElevatorPriceKind = () => {
            const { elevator_price_id,  selectedKind, elevator_price_kind_percent } = this.state
            if (selectedKind != "" && elevator_price_kind_percent != "" ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ elevator_price_kind_percent: "",  selectedElevatorKind: "" })
                                    self.getElevatorPriceKinds(elevator_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_kind")
                  fd.append("elevator_price_kind_elevator_price_id", elevator_price_id)
                  fd.append("elevator_price_kind_elevator_kind_id", selectedKind.value)
                  fd.append("elevator_price_kind_percent", elevator_price_kind_percent)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات افزوده نرخ نوع اسانسور را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewElevatorPriceUSeCase = () => {
            const { elevator_price_id,  selectedUses, elevator_usecase_type_percent } = this.state
            if (selectedUses != "" && elevator_usecase_type_percent != "" ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ selectedUses: "",  elevator_usecase_type_percent: "" })
                                    self.getElevatorPriceUses(elevator_price_id)

                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_use_case")
                  fd.append("elevator_price_uses_elevator_price_id", elevator_price_id)
                  fd.append("elevator_price_uses_elevator_uses_id", selectedUses.value)
                  fd.append("elevator_price_uses_percent", elevator_usecase_type_percent)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات افزوده نرخ نوع اسانسور را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewElevatorPriceStops = () => {
            const { elevator_price_id,  from_stops, to_stops, percent_stops } = this.state
            if (from_stops != "" && to_stops != "" && percent_stops !== "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ from_stops: "",  to_stops: "",  percent_stops : ""})
                                    self.getElevatorPriceStops(elevator_price_id)

                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_stops")
                  fd.append("elevator_price_stops_elevator_price_id", elevator_price_id)
                  fd.append("elevator_price_stops_from", from_stops)
                  fd.append("elevator_price_stops_to", to_stops)
                  fd.append("elevator_price_stops_percent", percent_stops)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات افزوده نرخ تعداد توقف را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewElevatorPriceLifeTime = () => {
            const { elevator_price_id,  from_life_time, to_life_time, percent_life_time } = this.state
            if (from_life_time != "" && to_life_time != "" && percent_life_time !== "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ from_life_time: "",  to_life_time: "",  percent_life_time : ""})
                                    self.getElevatorPriceLifeTime(elevator_price_id)

                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_life_time")
                  fd.append("elevator_price_life_time_elevator_price_id", elevator_price_id)
                  fd.append("elevator_price_life_time_from", from_life_time)
                  fd.append("elevator_price_life_time_to", to_life_time)
                  fd.append("elevator_price_life_time_percent", percent_life_time)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات افزوده نرخ سال ساخت را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }



      saveNewPriceElevatorCoverage = () => {
            const { elevator_price_id,  elevator_price_from_person, elevator_price_to_person, selectedElevatorCoverage, elevator_price_covarage_price } = this.state
            if (elevator_price_from_person  != "" && elevator_price_to_person != "" &&selectedElevatorCoverage != "" && elevator_price_covarage_price != "" ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ elevator_price_covarage_price: "", elevator_price_from_person : "", elevator_price_to_person : "", selectedElevatorCoverage: "" })
                                    self.ElevatorCovarage(elevator_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_covarage")
                  fd.append("elevator_price_covarage_elevator_price_id", elevator_price_id)
                  fd.append("elevator_price_covarage_price", elevator_price_covarage_price)
                  fd.append("elevator_price_coverage_from_person", elevator_price_from_person)
                  fd.append("elevator_price_coverage_to_person", elevator_price_to_person)
                  fd.append("elevator_price_covarage_price", elevator_price_covarage_price)
                  // fd.append("elevator_price_covarage_elevator_kinddoor_id", selectedElevatorKinddoor .value)
                  fd.append("elevator_price_covarage_elevator_covarage_id", selectedElevatorCoverage.value)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات نفرات و  بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changePriceElevator2 = () => {
            const {
                  elevator_price_id,
                  elevator_price_disc,
                  elevator_price_max_floor,
                  // elevator_price_amount,
                  elevator_price_extraprice_nodoor,
                  // elevator_price_rate,
                  elevator_price_extrapercent_nodoor,
                  elevator_price_min_floor,
                  elevator_price_until_year,
                  elevator_price_from_year,
                  selectedCompany,
                  // selectedKind,
                  // selectedUses,
                  elevator_price_deactive,
                  elevator_price_process_mode,
            } = this.state
            if (
                  selectedCompany != "" &&
                  // elevator_price_disc != "" &&
                  // elevator_price_amount != "" &&
                  elevator_price_extraprice_nodoor != "" &&
                  // elevator_price_rate != "" &&
                  elevator_price_extrapercent_nodoor != "" &&
                  elevator_price_max_floor != "" &&
                  elevator_price_min_floor != "" &&
                  elevator_price_until_year != "" &&
                  elevator_price_from_year != ""
                  // selectedKind != "" &&
                  // selectedUses != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceElevator()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_elevator_price")
                  fd.append("elevator_price_id", elevator_price_id)

                  fd.append("elevator_price_fieldcompany_id", selectedCompany.value)
                  // fd.append("elevator_price_kind_id", selectedKind.value)
                  // fd.append("elevator_price_uses_id", selectedUses.value)
                  fd.append("elevator_price_min_floor", elevator_price_min_floor)
                  // fd.append("elevator_price_amount", elevator_price_amount)
                  fd.append("elevator_price_extraprice_nodoor", elevator_price_extraprice_nodoor)
                  // fd.append("elevator_price_rate", elevator_price_rate)
                  fd.append("elevator_price_extrapercent_nodoor", elevator_price_extrapercent_nodoor)
                  fd.append("elevator_price_max_floor", elevator_price_max_floor)
                  fd.append("elevator_price_from_year", elevator_price_from_year)
                  fd.append("elevator_price_until_year", elevator_price_until_year)
                  fd.append("elevator_price_disc", elevator_price_disc)
                  fd.append("elevator_price_deactive", elevator_price_deactive)
                  fd.append("elevator_price_process_mode", elevator_price_process_mode)

                  xhttp.open("POST", `${constants.BASE_URL}/elevator`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }
      handleChangeElevatorPriceKindPercent = (event) => {
            this.setState({elevator_price_kind_percent : event});
      }
      handleChangeElevatorUseCasePercent = (event) => {
            this.setState({elevator_usecase_type_percent : event});
      }
      handleChangeElevatorFromStops = (event) => {
            this.setState({from_stops : event});
      }
      handleChangeElevatorToStops = (event) => {
            this.setState({to_stops : event});
      }
      handleChangeElevatorStopsPercent = (event) => {
            this.setState({percent_stops : event});
      }

      handleChangeElevatorFromLifeTime = (event) => {
            this.setState({from_life_time : event});
      }
      handleChangeElevatorToLifeTime = (event) => {
            this.setState({to_life_time : event});
      }
      handleChangeElevatorLifeTimePercent = (event) => {
            this.setState({percent_life_time : event});
      }

      handleChangeMinFloor = (event) => {
            this.setState({ elevator_price_min_floor: event })
      }

      // handleChangePriceAmount = (event) => {
      //       this.setState({ elevator_price_amount: event })
      // }
      handleChangeExtraPriceNoDoor = (event) => {
            this.setState({ elevator_price_extraprice_nodoor: event })
      }
      // handleChangePriceRate = (event) => {
      //       this.setState({ elevator_price_rate: event })
      // }

      handleChangeExtraPercentNoDoor = (event) => {
            this.setState({ elevator_price_extrapercent_nodoor: event })
      }
      handleChangeMaxFloor = (event) => {
            this.setState({ elevator_price_max_floor: event })
      }

      handleChangeFromYear = (event) => {
            this.setState({ elevator_price_from_year: event })
      }

      handleChangeMaxCapacity = (event) => {
            this.setState({ elevator_price_until_year: event })
      }

      handleChangeDisc = (event) => {
            this.setState({ elevator_price_disc: event })
      }
      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterPriceElevator = () => {
            const { selectedCompany,
                  // selectedUses,
                  requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (
                        (selectedCompany.value === 0 || temparray[i].elevator_price_fieldcompany_id === selectedCompany.value)
                        // (selectedUses === "" || selectedUses.value === 0 || temparray[i].elevator_price_uses_id === selectedUses.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            console.log(requestinfos)
            console.log(temparray2)
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  elevator_price_kindrespons_price,
                  elevator_price_covarage_price,
                elevator_price_from_person,
                elevator_price_to_person,
                  // elevator_price_rate,
                  elevator_price_extrapercent_nodoor,
                  elevator_price_extraprice_nodoor,
                  // elevator_price_amount,
                  elevator_price_max_floor,
                  elevator_price_min_floor,
                  elevator_price_until_year,
                  elevator_price_from_year,
                  elevator_price_disc,
                  selectedElevatorKindRespons,
                  selectedElevatorCoverage,
                  selectedElevatorKinddoor ,
                  optionCompany,
                  optionElevatorKinddoor ,
                  optionElevatorKindRespons,
                  optionElevatorKind,
                  optionElevatorCoverage,
                  optionKind,
                  optionUses,
                  elevatorKindRespons,
                  elevatorDisc,
                  snackMode,
                  snackstr,
                  showSnack,
                  newPriceElevator,
                  elevator_price_id,
                  company_logo_url,
                  selectedCompany,
                  selectedKind,
                  selectedUses,
                  elevator_price_deactive,
                  elevator_price_process_mode,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
                  elevatorPriceKinds,
                  elevator_price_kind_percent,
                 elevatorPriceUseCaseTypes,
                  elevatorPriceStops,
                elevator_usecase_type_percent,
                from_stops,
                to_stops,
                percent_stops,
                  from_life_time,
                  to_life_time,
                  percent_life_time,
                  elevatorPriceLifeTimes
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره قیمت بیمه آسانسور: " + elevator_price_id}
                                                                  </Typography>
                                                            </Grid>


                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={this.state.selectedCompany.logo} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            {/*<Grid item xs={6}>*/}
                                                            {/*      <div>*/}
                                                            {/*            <label className="on">نوع آسانسور </label>*/}
                                                            {/*            <Select*/}
                                                            {/*                  isSearchable={true}*/}
                                                            {/*                  className="adapter-txtsize"*/}
                                                            {/*                  placeholder={"نوع آسانسور"}*/}
                                                            {/*                  value={selectedKind}*/}
                                                            {/*                  onChange={this.handleKind}*/}
                                                            {/*                  options={optionKind}*/}
                                                            {/*            />*/}
                                                            {/*      </div>*/}
                                                            {/*</Grid>*/}

                                                            {/*<Grid item xs={6}>*/}
                                                            {/*      <div>*/}
                                                            {/*            <label className="on">نوع کاربری ساختمان</label>*/}
                                                            {/*            <Select*/}
                                                            {/*                  isSearchable={true}*/}
                                                            {/*                  className="adapter-txtsize"*/}
                                                            {/*                  placeholder={"نوع کاربری ساختمان"}*/}
                                                            {/*                  value={selectedUses}*/}
                                                            {/*                  onChange={this.handleUses}*/}
                                                            {/*                  options={optionUses}*/}
                                                            {/*            />*/}
                                                            {/*      </div>*/}
                                                            {/*</Grid>*/}

                                                            <Grid item xs={6}></Grid>
                                                            {/*<Grid item xs={6}>*/}
                                                            {/*      <FloatingLabelInput*/}
                                                            {/*            type="percent"*/}
                                                            {/*            placeholder="نرخ حق بیمه"*/}
                                                            {/*            handleInputt={this.handleChangePriceRate}*/}
                                                            {/*            value={elevator_price_rate}*/}
                                                            {/*      />*/}
                                                            {/*</Grid>*/}
                                                            {/*<Grid item xs={6}>*/}
                                                            {/*      <FloatingLabelInput*/}
                                                            {/*            type="currency"*/}
                                                            {/*            placeholder="مبلغ حق بیمه"*/}
                                                            {/*            handleInputt={this.handleChangePriceAmount}*/}
                                                            {/*            value={elevator_price_amount}*/}
                                                            {/*      />*/}
                                                            {/*</Grid>*/}

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="اضافه درصد نداشتن در کابین"
                                                                        handleInputt={this.handleChangeExtraPercentNoDoor}
                                                                        value={elevator_price_extrapercent_nodoor}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        placeholder="اضافه مبلغ نداشتن در کابین"
                                                                        handleInputt={this.handleChangeExtraPriceNoDoor}
                                                                        value={elevator_price_extraprice_nodoor}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="حداقل طبقات"
                                                                        handleInputt={this.handleChangeMinFloor}
                                                                        value={elevator_price_min_floor}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="حداکثر طبقات"
                                                                        handleInputt={this.handleChangeMaxFloor}
                                                                        value={elevator_price_max_floor}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="از سال ساخت"
                                                                        handleInputt={this.handleChangeFromYear}
                                                                        value={elevator_price_from_year}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="تا سال ساخت"
                                                                        handleInputt={this.handleChangeMaxCapacity}
                                                                        value={elevator_price_until_year}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="تخفیف"
                                                                        handleInputt={this.handleChangeDisc}
                                                                        value={elevator_price_disc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={elevator_price_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت قیمت شرکت بیمه"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                  <Switch
                                                                                      checked={elevator_price_process_mode === "1" ? true : false}
                                                                                      onChange={this.handleChangeProcessMode}
                                                                                      name="gilad"
                                                                                  />
                                                                            }
                                                                            label="محاسبه با بازه"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newPriceElevator ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.saveNewPriceElevator}
                                                                        >
                                                                              {"ثبت قیمت بیمه آسانسور جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newPriceElevator}
                                                                              >
                                                                                    {"قیمت بیمه آسانسور جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changePriceElevator2}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف قیمت بیمه آسانسور"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            {newPriceElevator ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            )}
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    {/*price coverage*/}
                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceElevator ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {elevatorDisc.map((elevatorDisc, index) => (

                                                                        <ElevatorCovarage
                                                                              elevatorDisc={elevatorDisc}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceElevator ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>

                                                                        <Grid item item xs={1}>
                                                                              <FloatingLabelInput
                                                                                  type="number"
                                                                                  placeholder="از نفر "
                                                                                  handleInputt={this.handleChangeFromPerson}
                                                                                  value={elevator_price_from_person}
                                                                              />
                                                                        </Grid>
                                                                        <Grid item item xs={1}>
                                                                              <FloatingLabelInput
                                                                                  type="number"
                                                                                  placeholder=" تا نفر "
                                                                                  handleInputt={this.handleChangeToPerson}
                                                                                  value={elevator_price_to_person}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item xs={3}>
                                                                              <div>
                                                                                    <label className="on"> پوشش بیمه نامه </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={" پوشش بیمه نامه"}
                                                                                          value={selectedElevatorCoverage}
                                                                                          onChange={this.handleElevatorCoverage}
                                                                                          options={optionElevatorCoverage}
                                                                                    />
                                                                              </div>
                                                                        </Grid>



                                                                        <Grid item item xs={3}>
                                                                              <FloatingLabelInput
                                                                                  type="currency"
                                                                                  placeholder=" قیمت بیمه نامه "
                                                                                  handleInputt={this.handleChangeElevatorCoverage}
                                                                                  value={elevator_price_covarage_price}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceElevatorCoverage}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>


                                    {/*reponsibilty*/}
                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceElevator ? null : (
                                                          <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                {elevatorKindRespons.map((elevatorKindRespons, index) => (
                                                                    <ElevatorKindRespons
                                                                        elevatorKindRespons={elevatorKindRespons}
                                                                        props={this.props}
                                                                        key={index}
                                                                    />
                                                                ))}
                                                          </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceElevator ? null : (
                                                          <Grid item xs={12}>
                                                                <Grid container spacing={3}>
                                                                      <Grid item xs={4}>
                                                                            <div>
                                                                                  <label className="on">  نوع مسئولیت </label>
                                                                                  <Select
                                                                                      isSearchable={true}
                                                                                      className="adapter-txtsize"
                                                                                      placeholder={" پوشش بیمه نامه"}
                                                                                      value={selectedElevatorKindRespons}
                                                                                      onChange={this.handleElevatorKindRespons}
                                                                                      options={optionElevatorKindRespons}
                                                                                  />
                                                                            </div>
                                                                      </Grid>






                                                                      <Grid item item xs={4}>
                                                                            <FloatingLabelInput
                                                                                type="percent"
                                                                                placeholder=" درصد اضافه نرخ"
                                                                                handleInputt={this.handleChangeElevatorKindRespons}
                                                                                value={elevator_price_kindrespons_price}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={4}>
                                                                            <div style={{ width: "100%", textAlign: "left" }}>
                                                                                  <Fab
                                                                                      className={classes.small}
                                                                                      color="primary"
                                                                                      aria-label="add"
                                                                                      onClick={this.saveNewPriceElevatorKindRespons}
                                                                                  >
                                                                                        <AddIcon />
                                                                                  </Fab>
                                                                            </div>
                                                                      </Grid>
                                                                </Grid>
                                                          </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>


                                    {/*elevator price kinds*/}
                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceElevator ? null : (
                                                          <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                {elevatorPriceKinds.map((elevatorPriceKind, index) => (
                                                                    <ElevatorPriceKind
                                                                        elevatorPriceKind={elevatorPriceKind}
                                                                        props={this.props}
                                                                        key={index}
                                                                    />
                                                                ))}
                                                          </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceElevator ? null : (
                                                          <Grid item xs={12}>
                                                                <Grid container spacing={3}>
                                                                      <Grid item xs={4}>
                                                                            <div>
                                                                                  <label className="on">  نوع آسانسور </label>
                                                                                  <Select
                                                                                      isSearchable={true}
                                                                                      className="adapter-txtsize"
                                                                                      placeholder={" نوع اسانسور"}
                                                                                      value={selectedKind}
                                                                                      onChange={this.handleKind}
                                                                                      options={optionKind}
                                                                                  />
                                                                            </div>
                                                                      </Grid>






                                                                      <Grid item item xs={4}>
                                                                            <FloatingLabelInput
                                                                                type="percent"
                                                                                placeholder=" درصد اضافه نرخ"
                                                                                handleInputt={this.handleChangeElevatorPriceKindPercent}
                                                                                value={elevator_price_kind_percent}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={4}>
                                                                            <div style={{ width: "100%", textAlign: "left" }}>
                                                                                  <Fab
                                                                                      className={classes.small}
                                                                                      color="primary"
                                                                                      aria-label="add"
                                                                                      onClick={this.saveNewElevatorPriceKind}
                                                                                  >
                                                                                        <AddIcon />
                                                                                  </Fab>
                                                                            </div>
                                                                      </Grid>
                                                                </Grid>
                                                          </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>


                                    {/*elevator use case types*/}
                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceElevator ? null : (
                                                          <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                {elevatorPriceUseCaseTypes.map((elevatorUseCaseType, index) => (
                                                                    <ElevatorPriceUses
                                                                        ElevatorPriceUses={elevatorUseCaseType}
                                                                        props={this.props}
                                                                        key={index}
                                                                    />
                                                                ))}
                                                          </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceElevator ? null : (
                                                          <Grid item xs={12}>
                                                                <Grid container spacing={3}>
                                                                      <Grid item xs={4}>
                                                                            <div>
                                                                                  <label className="on">  نوع کاربری </label>
                                                                                  <Select
                                                                                      isSearchable={true}
                                                                                      className="adapter-txtsize"
                                                                                      placeholder={"نوع کاربری"}
                                                                                      value={selectedUses}
                                                                                      onChange={this.handleUses}
                                                                                      options={optionUses}
                                                                                  />
                                                                            </div>
                                                                      </Grid>






                                                                      <Grid item item xs={4}>
                                                                            <FloatingLabelInput
                                                                                type="percent"
                                                                                placeholder=" درصد اضافه نرخ"
                                                                                handleInputt={this.handleChangeElevatorUseCasePercent}
                                                                                value={elevator_usecase_type_percent}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={4}>
                                                                            <div style={{ width: "100%", textAlign: "left" }}>
                                                                                  <Fab
                                                                                      className={classes.small}
                                                                                      color="primary"
                                                                                      aria-label="add"
                                                                                      onClick={this.saveNewElevatorPriceUSeCase}
                                                                                  >
                                                                                        <AddIcon />
                                                                                  </Fab>
                                                                            </div>
                                                                      </Grid>
                                                                </Grid>
                                                          </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    {/*elevator stops types*/}
                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceElevator ? null : (
                                                          <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                {elevatorPriceStops.map((elevatorStop, index) => (
                                                                    <ElevatorStops
                                                                        ElevatorPriceStops={elevatorStop}
                                                                        props={this.props}
                                                                        key={index}
                                                                    />
                                                                ))}
                                                          </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceElevator ? null : (
                                                          <Grid item xs={12}>
                                                                <Grid container spacing={3}>


                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="number"
                                                                                placeholder="از توقف"
                                                                                handleInputt={this.handleChangeElevatorFromStops}
                                                                                value={from_stops}
                                                                            />
                                                                      </Grid>
                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="number"
                                                                                placeholder="تا توقف"
                                                                                handleInputt={this.handleChangeElevatorToStops}
                                                                                value={to_stops}
                                                                            />
                                                                      </Grid>




                                                                      <Grid item item xs={4}>
                                                                            <FloatingLabelInput
                                                                                type="percent"
                                                                                placeholder=" درصد اضافه نرخ"
                                                                                handleInputt={this.handleChangeElevatorStopsPercent}
                                                                                value={percent_stops}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={4}>
                                                                            <div style={{ width: "100%", textAlign: "left" }}>
                                                                                  <Fab
                                                                                      className={classes.small}
                                                                                      color="primary"
                                                                                      aria-label="add"
                                                                                      onClick={this.saveNewElevatorPriceStops}
                                                                                  >
                                                                                        <AddIcon />
                                                                                  </Fab>
                                                                            </div>
                                                                      </Grid>
                                                                </Grid>
                                                          </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    {/*elevator lifetime types*/}
                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceElevator ? null : (
                                                          <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                {elevatorPriceLifeTimes.map((elevatorPriceLifeTime, index) => (
                                                                    <ElevatorPriceLifeTime
                                                                        ElevatorPriceLifeTime={elevatorPriceLifeTime}
                                                                        props={this.props}
                                                                        key={index}
                                                                    />
                                                                ))}
                                                          </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceElevator ? null : (
                                                          <Grid item xs={12}>
                                                                <Grid container spacing={3}>


                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="number"
                                                                                placeholder="از سال"
                                                                                handleInputt={this.handleChangeElevatorFromLifeTime}
                                                                                value={from_life_time}
                                                                            />
                                                                      </Grid>
                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="number"
                                                                                placeholder="تا سال"
                                                                                handleInputt={this.handleChangeElevatorToLifeTime}
                                                                                value={to_life_time}
                                                                            />
                                                                      </Grid>




                                                                      <Grid item item xs={4}>
                                                                            <FloatingLabelInput
                                                                                type="percent"
                                                                                placeholder=" درصد اضافه نرخ"
                                                                                handleInputt={this.handleChangeElevatorLifeTimePercent}
                                                                                value={percent_life_time}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={4}>
                                                                            <div style={{ width: "100%", textAlign: "left" }}>
                                                                                  <Fab
                                                                                      className={classes.small}
                                                                                      color="primary"
                                                                                      aria-label="add"
                                                                                      onClick={this.saveNewElevatorPriceLifeTime}
                                                                                  >
                                                                                        <AddIcon />
                                                                                  </Fab>
                                                                            </div>
                                                                      </Grid>
                                                                </Grid>
                                                          </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    {/*showing records*/}
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"elevator_price_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "elevator_price_id" ? order : false}
                                                                              >
                                                                                    {" آی دی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "elevator_price_id"}
                                                                                          direction={orderBy === "elevator_price_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("elevator_price_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              {/*<TableCell*/}
                                                                              {/*      key={"elevator_price_Kind_id"}*/}
                                                                              {/*      align={"center"}*/}
                                                                              {/*      style={{ minWidth: 60 }}*/}
                                                                              {/*>*/}
                                                                              {/*      {"نوع آسانسور "}*/}
                                                                              {/*      <TableSortLabel*/}
                                                                              {/*            active={orderBy === "elevator_price_Kind_id"}*/}
                                                                              {/*            direction={*/}
                                                                              {/*                  orderBy === "elevator_price_Kind_id"*/}
                                                                              {/*                        ? order*/}
                                                                              {/*                        : "asc"*/}
                                                                              {/*            }*/}
                                                                              {/*            onClick={(e) => {*/}
                                                                              {/*                  this.createSortHandler("elevator_price_Kind_id")*/}
                                                                              {/*            }}*/}
                                                                              {/*      ></TableSortLabel>*/}
                                                                              {/*</TableCell>*/}

                                                                              {/*<TableCell*/}
                                                                              {/*      key={"elevator_price_uses_id"}*/}
                                                                              {/*      align={"center"}*/}
                                                                              {/*      style={{ minWidth: 60 }}*/}
                                                                              {/*>*/}
                                                                              {/*      {" نوع کاربری ساختمان"}*/}
                                                                              {/*      <TableSortLabel*/}
                                                                              {/*            active={orderBy === "elevator_price_uses_id"}*/}
                                                                              {/*            direction={*/}
                                                                              {/*                  orderBy === "elevator_price_uses_id" ? order : "asc"*/}
                                                                              {/*            }*/}
                                                                              {/*            onClick={(e) => {*/}
                                                                              {/*                  this.createSortHandler("elevator_price_uses_id")*/}
                                                                              {/*            }}*/}
                                                                              {/*      ></TableSortLabel>*/}
                                                                              {/*</TableCell>*/}

                                                                              <TableCell
                                                                                    key={"elevator_price_min_floor"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"حداقل طبقات"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "elevator_price_min_floor"}
                                                                                          direction={
                                                                                                orderBy === "elevator_price_min_floor" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("elevator_price_min_floor")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"elevator_price_max_floor"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"حداکثر طبقات"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "elevator_price_max_floor"}
                                                                                          direction={
                                                                                                orderBy === "elevator_price_max_floor" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("elevator_price_max_floor")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"elevator_price_from_year"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"از سال ساخت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "elevator_price_from_year"}
                                                                                          direction={
                                                                                                orderBy === "elevator_price_from_year"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("elevator_price_from_year")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"elevator_price_until_year"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تا سال ساخت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "elevator_price_until_year"}
                                                                                          direction={
                                                                                                orderBy === "elevator_price_until_year"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("elevator_price_until_year")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"elevator_price_disc"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تخفیف"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "elevator_price_disc"}
                                                                                          direction={
                                                                                                orderBy === "elevator_price_disc" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("elevator_price_disc")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"elevator_price_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت قیمت بیمه آسانسور"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "elevator_price_deactive"}
                                                                                          direction={
                                                                                                orderBy === "elevator_price_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("elevator_price_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["elevator_price_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"elevator_price_id"} align={"center"}>
                                                                                                      {row["elevator_price_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"company_name"} align={"center"}>
                                                                                                      {row["company_name"]}
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["company_logo_url"]}
                                                                                                      />
                                                                                                </TableCell>

                                                                                                {/*<TableCell*/}
                                                                                                {/*      key={"elevator_price_Kind_id"}*/}
                                                                                                {/*      align={"center"}*/}
                                                                                                {/*>*/}
                                                                                                {/*      {row["elevator_kind_name"]}*/}
                                                                                                {/*</TableCell>*/}

                                                                                                {/*<TableCell*/}
                                                                                                {/*      key={"elevator_price_uses_id"}*/}
                                                                                                {/*      align={"center"}*/}
                                                                                                {/*>*/}
                                                                                                {/*      {row["elevator_uses_name"]}*/}
                                                                                                {/*</TableCell>*/}

                                                                                                <TableCell
                                                                                                      key={"elevator_price_min_floor"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["elevator_price_min_floor"]}
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                      key={"elevator_price_max_floor"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["elevator_price_max_floor"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"elevator_price_from_year"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["elevator_price_from_year"]}
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                      key={"elevator_price_until_year"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["elevator_price_until_year"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"elevator_price_disc"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["elevator_price_disc"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"elevator_price_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["elevator_price_deactive"] === "1" ||
                                                                                                      row["elevator_price_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه آسانسور را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deletePriceElevator} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePriceElevator)
